import { Box, Switch as MuiSwitch, SwitchProps, styled } from "@mui/material";

const StyledSwitch = styled((props: SwitchProps) => (
  <MuiSwitch disableRipple {...props} />
))(({ theme, size }) => ({
  padding: 0,
  width: size === "small" ? "51px" : "87px",
  height: size === "small" ? "28px" : "32px",
  "& .MuiSwitch-track": {
    borderRadius: "4px",
    border: "1px solid #181D1F26",
    backgroundColor: "#6B72800D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    // "&::before, &::after": {
    //   content: '""',
    //   position: "absolute",
    //   top: "50%",
    //   transform: "translateY(-50%)",
    //   width: 16,
    //   height: 16,
    // },
    // "&::before": {
    //   backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
    //     theme.palette.getContrastText(theme.palette.primary.main)
    //   )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
    //   left: 12,
    // },
    // "&::after": {
    //   backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
    //     theme.palette.getContrastText(theme.palette.primary.main)
    //   )}" d="M19,13H5V11H19V13Z" /></svg>')`,
    //   right: 12,
    // },
  },
  "& .MuiButtonBase-root.Mui-checked+.MuiSwitch-track": {
    borderColor: "#181D1F26",
    backgroundColor: "#6B72800D",
  },
  "& .MuiButtonBase-root": {
    padding: 0,
    margin: 0,
    left: size === "small" ? "42px" : "78px",
    right: "auto",
    transition: "left .35s",
    WebkitTransition: "left .35s",
    MozTransition: "left .35s",
    msTransition: "left .35s",
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: "9px",
      height: size === "small" ? "28px" : "32px",
      borderRadius: "4px",
      backgroundColor: "#FFFFFF",
      border: "1px solid #CCCCCC",
    },
    "& .MuiSwitch-input": {
      width: size === "small" ? "51px" : "87px",
      left: size === "small" ? "-42px" : "-78px",
    },
    "&.Mui-checked": {
      left: 0,
      transform: "none",
      "& .MuiSwitch-thumb": {
        borderRadius: "4px",
      },
      "& .MuiSwitch-input": {
        left: 0,
      },
    },
  },
}));

interface SwitchWithLabelsProps {
  onLabel: string;
  offLabel: string;
  checked: boolean;
  size?: "small" | "medium";
  onChange: (val: boolean) => void;
  fbmColor?: string;
  fbaColor?: string;
}

export const Switch: React.FunctionComponent<SwitchWithLabelsProps> = ({
  onLabel,
  offLabel,
  checked,
  size = "small",
  onChange,
  fbmColor,
  fbaColor,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      <StyledSwitch
        checked={checked}
        onChange={handleChange}
        size={size}
        sx={{
          "& .MuiSwitch-track": {
            backgroundColor: checked
              ? fbmColor || "#6B72800D"
              : fbaColor || "#6B72800D",
          },
          "& .MuiButtonBase-root.Mui-checked+.MuiSwitch-track": {
            backgroundColor: fbmColor || "#6B72800D",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          fontSize: "12px",
          lineHeight: size === "small" ? "28px" : "32px",
          fontWeight: 500,
          top: "0px",
          right: checked ? "10px" : size === "small" ? "-41px" : "-77px",
          transition: "right .35s",
          WebkitTransition: "right .35s",
          MozTransition: "right .35s",
          msTransition: "right .35s",
          pointerEvents: "none",
        }}
      >
        {onLabel}
      </Box>
      <Box
        sx={{
          position: "absolute",
          fontSize: "12px",
          lineHeight: size === "small" ? "28px" : "32px",
          fontWeight: 500,
          top: "0px",
          left: !checked ? "10px" : size === "small" ? "-41px" : "-77px",
          transition: "left .35s",
          WebkitTransition: "left .35s",
          MozTransition: "left .35s",
          msTransition: "left .35s",
          pointerEvents: "none",
        }}
      >
        {offLabel}
      </Box>
    </Box>
  );
};

export default Switch;
